import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';
var IconLink = function (_a) {
    var to = _a.to, icon = _a.icon, title = _a.title, _b = _a.external, external = _b === void 0 ? false : _b;
    var children = title ? React.createElement(Tooltip, { title: title }, icon) : icon;
    if (external)
        return (React.createElement("a", { href: to, target: "_blank", rel: "noopener noreferrer" }, children));
    return React.createElement(Link, { to: to }, children);
};
export default IconLink;
